import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const SectionWithHeading = styled.div`
  ${props =>
    props.withoutPadding
      ? ''
      : `
    padding-top: 20px;
  `}
  ${props =>
    props.withPaddingTop
      ? `
    padding-top: 20px;
  `
      : ''}
  ${props =>
    props.withPaddingBottom
      ? `
    padding-bottom: 20px !important;
  `
      : ''}
  display: flex;
  flex-direction: column;

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
  }

  button.show-more {
    margin-top: 28px;
    align-self: center;
  }

  .slick-list {
    padding-top: 12px;
    padding-left: 3px;
  }
`

export const SectionLink = styled(Link)`
  font-size: 12px;
  color: ${props => props.theme.color.black2};
  text-decoration: none;

  svg {
    margin-left: 9px;
  }
  @media screen and (min-width: 1100px) {
    ${props => props.theme.font.size.sm};
  }
`

export const HeadingContainer = styled.span`
  font-family: 'Firago-Medium';
  line-height: 29px;
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
`

export const SectionHeading = styled.h2`
  width: 80%;
  font-family: ${props => props.theme.font.family.bold2};
  font-weight: bolder;
  font-size: 24px;
  color: ${props => props.theme.color.black};
  padding-bottom: 10px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 25px;
  span {
    font-family: 'Firago-Medium';
    line-height: 29px;
    display: flex;
  }
  .desktop-countdown {
    @media screen and (min-width: 700px) {
      margin-left: 20px;
    }
  }

  @media screen and (min-width: 1100px) {
    font-size: ${props => props.theme.font.size.lg};
  }
  @media screen and (max-width: 500px) {
    font-size: 18px;
  }
  @media screen and (max-width: 400px) {
    font-size: 16px;
  }
  @media screen and (max-width: 380px) {
    font-size: 15px;
  }
  @media screen and (max-width: 360px) {
    font-size: 14px;
  }
`

export const SectionHeadingH1 = styled.h2`
  font-family: ${props => props.theme.font.family.bold};
  font-size: 20px;
  color: ${props => props.theme.color.black};
  padding-bottom: 8px;
  margin-top: 15px;
  border-bottom: 1px solid ${props => props.theme.color.greyED};
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media screen and (min-width: 1100px) {
    font-size: ${props => props.theme.font.size.lg};
  }
`
